/* ============================================================
   RR FILTER SYSTEM v5 — JavaScript
   Terra Luna India
   Approach: simple, reliable URL-based filtering.
   No AJAX section rendering (was causing blank pages).
   Filters apply via URL navigation — Shopify handles rendering.
   ============================================================ */

(function () {
  'use strict';

  var $body = document.body;

  function $(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ============================================================
     SAFE CLEANUP — closes all overlays/drawers
  ============================================================ */
  function cleanupAll() {
    $body.classList.remove('rr-locked');
    var sidebar = $('.rr-sidebar');
    if (sidebar) sidebar.classList.remove('is-open');
    var mobileDrawer = $('.rr-mobile-drawer');
    if (mobileDrawer) mobileDrawer.classList.remove('is-open');
    var sortSheet = $('.rr-sort-sheet');
    if (sortSheet) sortSheet.classList.remove('is-open');
    var sortPanel = $('.rr-sort-panel');
    if (sortPanel) sortPanel.classList.remove('is-open');
    $$('.rr-sidebar-overlay, .rr-sort-overlay').forEach(function(el) {
      el.classList.remove('is-open');
    });
    $$('.rr-js-open-filter').forEach(function(b) { b.classList.remove('is-active'); });
    var sortBtn = $('.rr-dfb__sort-btn');
    if (sortBtn) sortBtn.classList.remove('is-active');
  }

  /* ============================================================
     BUILD FILTER URL FROM FORM STATE
  ============================================================ */
  function buildUrlFromContainer(container, sortOverride) {
    var url = new URL(window.location.href);

    /* Clear existing filter + sort params */
    var toDelete = [];
    url.searchParams.forEach(function(v, k) {
      if (k.startsWith('filter.') || k === 'sort_by') toDelete.push(k);
    });
    toDelete.forEach(function(k) { url.searchParams.delete(k); });
    url.searchParams.delete('page');

    if (container) {
      /* Collect checked checkboxes */
      $$('.rr-checkbox:checked', container).forEach(function(cb) {
        url.searchParams.append(cb.name, cb.value);
      });
      /* Collect price range */
      var priceMin = $('.rr-price-input[data-price-type="min"]', container);
      var priceMax = $('.rr-price-input[data-price-type="max"]', container);
      if (priceMin && priceMin.value.trim() !== '') url.searchParams.set(priceMin.name, priceMin.value);
      if (priceMax && priceMax.value.trim() !== '') url.searchParams.set(priceMax.name, priceMax.value);
    }

    /* Sort */
    if (sortOverride) {
      url.searchParams.set('sort_by', sortOverride);
    } else {
      /* Preserve existing sort if any */
      var existingSort = new URLSearchParams(window.location.search).get('sort_by');
      if (existingSort) url.searchParams.set('sort_by', existingSort);
    }

    return url.toString();
  }

  /* ============================================================
     NAVIGATE TO FILTERED URL
  ============================================================ */
  function navigateTo(url) {
    cleanupAll();
    /* Show a brief loading state then navigate */
    var bar = $('#rrLoadingBar');
    if (bar) { bar.classList.add('is-loading'); }
    window.location.href = url;
  }

  /* ============================================================
     SYNC CHECKBOXES TO CURRENT URL STATE
     (so when drawer opens, already-active filters are checked)
  ============================================================ */
  function syncCheckboxesToUrl(container) {
    var params = new URLSearchParams(window.location.search);
    $$('.rr-checkbox', container).forEach(function(cb) {
      var vals = params.getAll(cb.name);
      cb.checked = vals.indexOf(cb.value) !== -1;
    });
  }

  /* ============================================================
     DESKTOP SIDEBAR
  ============================================================ */
  function initDesktopSidebar() {
    var sidebar     = $('.rr-sidebar');
    var overlay     = $('.rr-sidebar-overlay');
    var openBtns    = $$('.rr-js-open-filter');
    var closeBtns   = $$('.rr-sidebar__close-btn');
    var applyBtns   = $$('.rr-sidebar__apply-btn');
    var groupBtns   = $$('[data-rr-group]', sidebar);
    var valuePanels = $$('[data-rr-values]', sidebar);
    if (!sidebar) return;

    var currentGroup = 0;

    function openSidebar() {
      sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      $body.classList.add('rr-locked');
      openBtns.forEach(function(b) { b.classList.add('is-active'); });
      syncCheckboxesToUrl(sidebar);
      showGroup(currentGroup);
    }
    function closeSidebar() {
      sidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      $body.classList.remove('rr-locked');
      openBtns.forEach(function(b) { b.classList.remove('is-active'); });
    }
    function showGroup(idx) {
      groupBtns.forEach(function(b, i) { b.classList.toggle('is-active', i === idx); });
      valuePanels.forEach(function(p, i) { p.style.display = (i === idx) ? 'block' : 'none'; });
      currentGroup = idx;
    }

    openBtns.forEach(function(btn) { btn.addEventListener('click', openSidebar); });
    if (overlay) overlay.addEventListener('click', closeSidebar);
    closeBtns.forEach(function(btn) { btn.addEventListener('click', closeSidebar); });
    applyBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var url = buildUrlFromContainer(sidebar, null);
        navigateTo(url);
      });
    });
    groupBtns.forEach(function(btn, i) {
      btn.addEventListener('click', function() { showGroup(i); });
    });

    /* Show first group on init */
    if (groupBtns.length) showGroup(0);
  }

  /* ============================================================
     MOBILE DRAWER
  ============================================================ */
  function initMobileDrawer() {
    var drawer      = $('.rr-mobile-drawer');
    var openBtns    = $$('.rr-js-open-mobile-filter');
    var closeBtn    = $('.rr-mobile-drawer__close-btn');
    var applyBtn    = $('.rr-mobile-drawer__apply-btn');
    var groupBtns   = $$('[data-rr-m-group]', drawer);
    var valuePanels = $$('[data-rr-m-values]', drawer);
    var mCurrent    = 0;
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      $body.classList.add('rr-locked');
      syncCheckboxesToUrl(drawer);
      showMGroup(mCurrent);
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      $body.classList.remove('rr-locked');
    }
    function showMGroup(idx) {
      groupBtns.forEach(function(b, i) { b.classList.toggle('is-active', i === idx); });
      valuePanels.forEach(function(p, i) { p.style.display = (i === idx) ? 'block' : 'none'; });
      mCurrent = idx;
    }

    openBtns.forEach(function(btn) { btn.addEventListener('click', openDrawer); });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (applyBtn) applyBtn.addEventListener('click', function() {
      var url = buildUrlFromContainer(drawer, null);
      navigateTo(url);
    });
    groupBtns.forEach(function(btn, i) {
      btn.addEventListener('click', function() { showMGroup(i); });
    });
    if (groupBtns.length) showMGroup(0);
  }

  /* ============================================================
     DESKTOP SORT DROPDOWN
  ============================================================ */
  function initDesktopSort() {
    /* Delegated handling: bound once to document, so it works regardless of
       when the filter bar markup appears or whether it gets re-rendered.
       (Previous version bound directly to the button at init time, which
       silently failed if the element wasn't ready / was replaced.) */
    if (document.documentElement.dataset.rrSortBound) return;
    document.documentElement.dataset.rrSortBound = '1';

    document.addEventListener('click', function (e) {
      var t = e.target;
      var panel = $('.rr-sort-panel');

      /* 1. Click on a sort option inside the desktop panel → navigate */
      var item = t.closest ? t.closest('.rr-sort-panel .rr-sort-panel__item') : null;
      if (item) {
        e.preventDefault();
        e.stopPropagation();
        var sortVal = item.dataset.sortValue || '';
        navigateTo(buildUrlFromContainer(null, sortVal || null));
        return;
      }

      /* 2. Click on the SORT BY button → toggle the panel */
      var sortBtn = t.closest ? t.closest('.rr-dfb__sort-btn') : null;
      if (sortBtn) {
        e.preventDefault();
        if (panel) {
          var isOpen = panel.classList.toggle('is-open');
          sortBtn.classList.toggle('is-active', isOpen);
        }
        return;
      }

      /* 3. Click anywhere else → close an open panel */
      if (panel && panel.classList.contains('is-open') &&
          !(t.closest && t.closest('.rr-dfb__sort-wrap'))) {
        panel.classList.remove('is-open');
        var b = $('.rr-dfb__sort-btn');
        if (b) b.classList.remove('is-active');
      }
    });
  }

  /* ============================================================
     MOBILE SORT BOTTOM SHEET
  ============================================================ */
  function initMobileSortSheet() {
    var overlay  = $('.rr-sort-overlay');
    var sheet    = $('.rr-sort-sheet');
    var openBtns = $$('.rr-js-open-sort');
    var closeBtn = $('.rr-sort-sheet__close');
    var items    = $$('.rr-sort-sheet__item');
    if (!sheet) return;

    function openSheet() {
      if (overlay) overlay.classList.add('is-open');
      sheet.classList.add('is-open');
      $body.classList.add('rr-locked');
    }
    function closeSheet() {
      if (overlay) overlay.classList.remove('is-open');
      sheet.classList.remove('is-open');
      $body.classList.remove('rr-locked');
    }

    openBtns.forEach(function(b) { b.addEventListener('click', openSheet); });
    if (overlay) overlay.addEventListener('click', closeSheet);
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    items.forEach(function(item) {
      item.addEventListener('click', function() {
        var sortVal = item.dataset.sortValue || '';
        var url = buildUrlFromContainer(null, sortVal || null);
        navigateTo(url);
      });
    });
  }

  /* ============================================================
     ACTIVE TAG REMOVAL (href-based, just navigate)
  ============================================================ */
  function initActiveTagRemoval() {
    $$('.rr-active-tag-remove').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        navigateTo(link.href);
      });
    });
    var clearAll = $('.rr-active-tags__clear');
    if (clearAll) {
      clearAll.addEventListener('click', function(e) {
        e.preventDefault();
        navigateTo(clearAll.href);
      });
    }
  }

  /* Escape key safety */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') cleanupAll();
  });

  /* ============================================================
     INIT
  ============================================================ */
  function init() {
    initDesktopSidebar();
    initMobileDrawer();
    initDesktopSort();
    initMobileSortSheet();
    initActiveTagRemoval();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
